export function profanityFilter(word) {
    word = word.replace(/\W/ig, '');
    
    const profanityList = [
        "anal",
        "anus",
        "arse",
        "ass",
        "ballsack",
        "balls",
        "bastard",
        "bitch",
        "biatch",
        "bloody",
        "blowjob",
        "bollock",
        "bollok",
        "boner",
        "boob",
        "bugger",
        "bum",
        "butt",
        "buttplug",
        "clitoris",
        "cock",
        "coon",
        "crap",
        "cunt",
        "damn",
        "dick",
        "dildo",
        "dyke",
        "fag",
        "feck",
        "fellate",
        "fellatio",
        "felching",
        "fuck",
        "fudgepacker",
        "flange",
        "goddamn",
        "god damn",
        "hell",
        "homo",
        "jerk",
        "jizz",
        "knobend",
        "labia",
        "lmao",
        "lmfao",
        "muff",
        "nigger",
        "nigga",
        "omg",
        "penis",
        "piss",
        "poop",
        "prick",
        "pube",
        "pussy",
        "queer",
        "scrotum",
        "sex",
        "shit",
        "sh1t",
        "slut",
        "smegma",
        "spunk",
        "tit",
        "tosser",
        "turd",
        "twat",
        "vagina",
        "wank",
        "whore",
        "wtf",
        "fuk",
        "fuckhead",
        "fuckme",
        "fukme",
        "fucme",
        "fukhead",
        "fuckboy",
        "fukboy",
        "fuckboi",
        "fuc",
        "fucboy",
        "fuccboy",
        "indeed", 
        "linkedin", 
        "careerone", 
        "covid", 
        "covid19", 
        "corona", 
        "coronavirus", 
        "scottyfrommarketing", 
        "scomo",
        "slag",
        "skank",
    ]

    const bannedSubstringList = [
        "http", 
        "https", 
        "www",
        "fuck",
        "covid"
    ]

    let substringCheck = false;
    for (let i = 0, n = bannedSubstringList.length; i < n; i++) {
        if (word.includes(bannedSubstringList[i])) {
            substringCheck = true;
            break;
        }
    }

    const profanityCheck = profanityList.find((item) => item === word);
    if (profanityCheck || substringCheck) {
        return false;
    }
    return true;
}